import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { colors, Modal } from 'design-system';
import { Dispatch, SetStateAction } from 'react';
import { useStylesHelpModal } from '../IndividualDeductibles/DeductibleHelpModal';

export interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const ExemptionCoverageModal = ({
  open,
  setOpen,
}: Props): JSX.Element => {
  const classesHelpModal = useStylesHelpModal();
  const theme = useTheme();
  const smQuery = useMediaQuery(theme.breakpoints.down('md'));

  const handleCloseModal = () => setOpen(false);

  return (
    <Modal
      data-testid="exemption-help-modal"
      title={
        <Typography
          style={{
            color: smQuery ? '#0D2E68' : colors.white,
            paddingInline: smQuery ? '3rem' : '0',
          }}
          align="center"
        >
          Cobertura de Deducible
        </Typography>
      }
      open={open}
      maxWidth="sm"
      onCloseRequested={handleCloseModal}
    >
      <Grid
        container
        item
        justifyContent="center"
        className={
          smQuery
            ? classesHelpModal.rootContainer
            : classesHelpModal.rootContainerLarge
        }
        style={{ paddingBottom: '1rem' }}
      >
        <Grid item container justifyContent="center" data-testid="first-page">
          <Grid item>
            <img
              src="/svg/deductible_coverage.svg"
              alt="exemption_car"
              style={{ width: '100%' }}
            />
          </Grid>

          <Grid
            item
            container
            spacing={1}
            justifyContent="center"
            style={{ maxWidth: '480px', marginTop: 20, marginBottom: 20 }}
          >
            <Grid item xs={12} container justifyContent="center">
              <Typography
                align="center"
                className={classesHelpModal.textTitle}
                style={{ fontSize: 15, fontWeight: 400 }}
              >
                <strong>¿Cómo funciona la cobertura de deducible?</strong>
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <Typography
                align="center"
                color="secondary"
                className={classesHelpModal.textDescriptionExemption}
              >
                En caso de reclamos por colisión o vuelco y comprensivo,
                {smQuery ? ' ' : <br />}
                <strong>ASSA exonera el 100% del deducible</strong> aunque seas
                responsable.
                <br />
                <br />
                La exoneración aplica siempre y cuando el monto a indemnizar
                supere el deducible establecido originalmente en la póliza.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
